export interface TemplateConfig {
  id: string
  displayName: string // Display file name
  description: string // Brief description
  downloadUrl: string // Download link
  type: 'price' | 'zone' | 'both' // Applicable converter type
}

// All template configurations
export const RATE_CARD_TEMPLATES: TemplateConfig[] = [
  // Price sheet templates
  {
    id: '1',
    displayName: 'Standard Price Sheet Template 1',
    description: 'Basic template with OZS and LBS weight units',
    downloadUrl: '/documents/standard_rate_card_template.xlsx',
    type: 'price'
  },
  {
    id: '4',
    displayName: 'Standard Price Sheet Template 2',
    description: 'Basic template with OZS and LBS weight units',
    downloadUrl: '/documents/standard_rate_card_template_2.xlsx',
    type: 'price'
  },
  {
    id: '3',
    displayName: 'Multi-Zone Naming Convention',
    description:
      'Sample template showing various supported zone naming formats',
    downloadUrl: '/documents/multi_zone_naming_rate_card_template.xlsx',
    type: 'price'
  },

  // Zone sheet templates
  {
    id: '5',
    displayName: 'Standard Zone Sheet Template',
    description: 'Basic template with Zip Code, Gateway, and Zone mapping',
    downloadUrl: '/documents/standard_zone_sheet_template.xlsx',
    type: 'zone'
  }
]

// Get templates by converter type
export const getTemplatesByType = (
  type: 'price' | 'zone'
): TemplateConfig[] => {
  return RATE_CARD_TEMPLATES.filter(
    template => template.type === type || template.type === 'both'
  )
}
